import { useSocialCategories } from '@/hooks/apiHooks';
import { useEffect, useState } from 'react';
import { CategoryType } from '@/types/api';
import {
  CommentPositionOptions,
  DisplaySectionOptions,
  ImportantOptions,
  UploadTimeOptions,
} from '@/constant/boardForm';

export type BoardOption = {
  readonly value: string;
  readonly label: string;
};

export type BoardFormOptions = {
  _categories: CategoryType[];
  categoryOptions: BoardOption[];
  displaySectionOptions: BoardOption[];
  commentPositionOptions: {
    id: string;
    label: string;
    selected_image: string;
    image: string;
  }[];
  uploadTimeOptions: BoardOption[];
  importantOptions: BoardOption[];
};

const useBoardFormOptions = (): BoardFormOptions => {
  const { data: _categories } = useSocialCategories(false, undefined, {
    revalidateOnFocus: false,
  });
  const [categoryOptions, setCategoryOptions] = useState<BoardOption[]>([]);

  useEffect(() => {
    if (_categories) {
      setCategoryOptions(
        _categories
          .map((category) => ({
            label: category.name,
            value: category.id,
          }))
          .sort((a, b) => a.label.localeCompare(b.label)),
      );
    }
  }, [_categories]);

  return {
    _categories: _categories || [],
    categoryOptions,
    displaySectionOptions: DisplaySectionOptions,
    commentPositionOptions: CommentPositionOptions,
    uploadTimeOptions: UploadTimeOptions,
    importantOptions: ImportantOptions,
  };
};

export default useBoardFormOptions;
